import { render, staticRenderFns } from "./Refunds.vue?vue&type=template&id=2b0f7aa8&scoped=true"
import script from "./Refunds.vue?vue&type=script&lang=js"
export * from "./Refunds.vue?vue&type=script&lang=js"
import style0 from "./Refunds.vue?vue&type=style&index=0&id=2b0f7aa8&prod&scoped=true&lang=css"
import style1 from "./Refunds.vue?vue&type=style&index=1&id=2b0f7aa8&prod&scoped=true&lang=css"
import style2 from "./Refunds.vue?vue&type=style&index=2&id=2b0f7aa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0f7aa8",
  null
  
)

export default component.exports